import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { Question, QuestionTypes } from 'onboarding/question/Question';
import { Info } from '../info/Info';
import { TextOption } from './TextOption';

export class OptionalQuestion extends Question {
  sourceQuestionId: QuestionIds;
  options: Record<string, OptionQuestion | Info>;

  constructor(
    sourceQuestionId: QuestionIds,
    questionId: QuestionIds,
    options: Record<string, OptionQuestion | Info>,
    hasStepper?: boolean,
  ) {
    super(
      QuestionTypes.Optional,
      questionId,
      hasStepper ?? Object.values(options)[0].type === QuestionTypes.Option,
    );
    this.sourceQuestionId = sourceQuestionId;
    this.options = options;
  }
}

export class OptionQuestion extends Question {
  title: string;
  description?: string;
  options: TextOption[];
  multiple: boolean;

  constructor(
    id: QuestionIds,
    title: string,
    options: TextOption[],
    multiple = false,
    hasStepper = true,
    description?: string,
  ) {
    super(QuestionTypes.Option, id, hasStepper);

    this.id = id;
    this.title = title;
    this.description = description;
    this.options = options;
    this.multiple = multiple;
  }

  hasOptionId(id: string): boolean {
    for (const option of this.options) {
      if (option.id === id) {
        return true;
      }
    }
    return false;
  }
}
